import React from 'react'
import {
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  IconButton,
  Box, FormControl, InputLabel, CircularProgress, MenuItem, Select, useTheme
} from '@mui/material'
import { alpha } from '@mui/material/styles'

import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close'
import { useGetListsQuery } from 'src/services/lists-service.js'
import { useSelector } from 'react-redux'

const ExportCsvDialog = ({ openDialog, handleCloseDialog, handleDownloadCsvClick, verifyLeads, setVerifyLeads, list, setListId, listId }) => {
  const theme = useTheme()
  const handleChange = (event, value) => {
    // Convert string 'true'/'false' to boolean
    const boolValue = value === 'true'
    setVerifyLeads(boolValue)
  }

  const currentWorkspace = useSelector((state) => state.workspace)
  const { data: lists } = useGetListsQuery({
    workspaceId: currentWorkspace?._id
  })
  const isLoadingLists = false
  return (
    <Box
      open={openDialog}
      onClose={handleCloseDialog}
      minWidth='503px'
      fullWidth
      sx={{
        border: '1px solid #E4E4E5',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '16px'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
        <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>
          {!list ? "Export as CSV" : "Add to List"}
        </Typography>
        <IconButton
          aria-label='close'
          onClick={handleCloseDialog}
          sx={{ height: '20px', width: '20px' }}
        >
          <CloseIcon sx={{ color: '#101010' }} />
        </IconButton>
      </Box>

      <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
        {!list ? "Would you like to validate the email addresses?" : "Please select the list"}
      </Typography>
      {!list ?
      (
      <RadioGroup
        value={verifyLeads.toString()} // Convert boolean to string for RadioGroup
        onChange={handleChange}
        sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
      >
        <FormControlLabel
          value='true'
          control={<Radio />}
          label='Yes'
          sx={{
            border: '1px solid #D7D9E6',
            height: '45px',
            borderRadius: '8px',
            mb: 1,
            width: '48%',
            margin: 0,
            padding: '8px 16px',

            '& .MuiFormControlLabel-label': {
              fontSize: '14px',
              fontWeight: 500
            }
          }}
        />

        <FormControlLabel
          value='false'
          control={<Radio />}
          label='No'
          sx={{
            height: '45px',
            border: '1px solid #D7D9E6',
            borderRadius: '8px',
            width: '48%',
            margin: 0,
            padding: '8px 16px',
            '& .MuiFormControlLabel-label': {
              fontSize: '14px',
              fontWeight: 500
            }
          }}
        />
      </RadioGroup>) : (<></>)
      }
      {list ?
      (<FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel
          id='select-list-label'
          sx={{
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '18px',
            letterSpacing: '0px',
            color: alpha(theme.palette.primary.main, 0.8)
          }}
        >
          Select List
        </InputLabel>
        <Select
          labelId='select-list-label'
          value={listId || ''}
          onChange={(e) => setListId(e.target.value)}
          label='Select List'
          sx={{
            backgroundColor: 'white',
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: '8px',
              border: '1px solid #E4E4E5'
            },
            '& .MuiSelect-select': {
              py: 2,
              fontSize: '13px',
              fontWeight: 400,
              lineHeight: '16px',
              letterSpacing: '0em'
            }
          }}
        >
          {isLoadingLists
            ? (
              <MenuItem disabled>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CircularProgress size={20} />
                  Loading lists...
                </Box>
              </MenuItem>
            )
            : lists?.docs?.length > 0
              ? (
                lists.docs.map((list) => (
                  <MenuItem
                    key={list._id}
                    value={list._id}
                    sx={{
                      fontSize: '13px',
                      fontWeight: 500,
                      lineHeight: '16px',
                      color: alpha(theme.palette.primary.main, 0.8)
                    }}
                  >
                    {list.name}
                  </MenuItem>
                ))
              )
              : (
                <MenuItem disabled>No lists available</MenuItem>
              )}
        </Select>
      </FormControl>) : <></>
      }

      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        padding: '12px 16px',
        backgroundColor: '#f0f7ff',
        borderRadius: '4px',
        marginTop: '16px',
        marginBottom: '16px'
      }}>
        <InfoIcon sx={{ color: '#1976d2', marginRight: '8px' }} />
        <Typography>
          Leads you've already downloaded <span style={{ color: '#d32f2f', fontWeight: 600 }}>won't be included</span> in your new downloads. You'll find them in the "Saved" tab (coming soon).
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          onClick={handleCloseDialog} variant='outlined'
          sx={{
            height: '48px',
            width: '76px',
            border: '1px solid #E4E4E5',
            borderRadius: '12px'

          }}
        >
          <Typography sx={{
            fontSize: '14px',
            fontWeight: 600,
            color: '#101010'
          }}
          >Cancel
          </Typography>
        </Button>

        <Button
          onClick={handleDownloadCsvClick}
          variant='contained'
          disabled={list && !listId}
          sx={{
            height: '48px',
            width: '208px',
            borderRadius: '12px',
            backgroundColor: `${theme.palette.primary.main}`,
            '&:hover': {
              backgroundColor: `${theme.palette.primary.dark}`
            }
          }}
        >
          <Typography sx={{
            fontSize: '14px',
            fontWeight: 600
          }}
          >{!list ? "Export leads" : "Add to List"}
          </Typography>
        </Button>
      </Box>

    </Box>
  )
}

export default ExportCsvDialog
